
export const maintainInfoRouting = [
	{
    path: "/assetManage/maintainInfo/list",
    name: "maintainInfo-list",
    meta: { title: "维修信息登记" },
    component: () =>
      import(/* webpackChunkName: "maintainInfo-list" */ "@/views/asset-management/maintainInfo/list/index.vue"),
  },
	{
    path: "/assetManage/maintainInfo/create",
    name: "maintainInfo-create",
    meta: { title: "新建维修登记" },
		hidden: true,
    component: () =>
      import(/* webpackChunkName: "maintainInfo-create" */ "@/views/asset-management/maintainInfo/form-create/index.vue"),
  },
	{
    path: "/assetManage/maintainInfo/edit/:id",
    name: "maintainInfo-edit",
    meta: { title: "编辑维修登记" },
		hidden: true,
    component: () =>
      import(/* webpackChunkName: "maintainInfo-edit" */ "@/views/asset-management/maintainInfo/form-create/index.vue"),
  },
	{
    path: "/assetManage/maintainInfo/detail/:id",
    name: "maintainInfo-detail",
    meta: { title: "维修登记详情" },
		hidden: true,
    component: () =>
      import(/* webpackChunkName: "maintainInfo-detail" */ "@/views/asset-management/maintainInfo/form-detail/index.vue"),
  },
]